import React, { ComponentType, FC } from 'react';
import { useLocation } from 'react-router-dom';
import { compose } from 'redux';
import {
    Themable,
    TThemableProps,
} from '@/app/pages/PasswordResetPage/Themable.hoc';

const PasswordResetExternalPage: FC<TThemableProps> = ({ classes }) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const mobile = params.get('mobile');

    const iframeSrc = `/embed/account/password-reset${
        token || mobile ? '?' : ''
    }${token ? `token=${encodeURIComponent(token)}` : ''}${
        token && mobile ? '&' : ''
    }${mobile ? `mobile=${encodeURIComponent(mobile)}` : ''}`;

    return (
        <div className={classes.root}>
            <iframe style={{ width: '100%', height: '100%' }} src={iframeSrc} />
        </div>
    );
};

export default compose(Themable)(PasswordResetExternalPage) as ComponentType;
